/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiOrganisation } from './ApiOrganisation';
import {
    ApiOrganisationFromJSON,
    ApiOrganisationFromJSONTyped,
    ApiOrganisationToJSON,
    ApiOrganisationToJSONTyped,
} from './ApiOrganisation';

/**
 * 
 * @export
 * @interface OrganisationsPage
 */
export interface OrganisationsPage {
    /**
     * 
     * @type {number}
     * @memberof OrganisationsPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationsPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationsPage
     */
    total: number;
    /**
     * 
     * @type {Array<ApiOrganisation>}
     * @memberof OrganisationsPage
     */
    content: Array<ApiOrganisation>;
}

/**
 * Check if a given object implements the OrganisationsPage interface.
 */
export function instanceOfOrganisationsPage(value: object): value is OrganisationsPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function OrganisationsPageFromJSON(json: any): OrganisationsPage {
    return OrganisationsPageFromJSONTyped(json, false);
}

export function OrganisationsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganisationsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(ApiOrganisationFromJSON)),
    };
}

export function OrganisationsPageToJSON(json: any): OrganisationsPage {
    return OrganisationsPageToJSONTyped(json, false);
}

export function OrganisationsPageToJSONTyped(value?: OrganisationsPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(ApiOrganisationToJSON)),
    };
}

